import React, { useState, useEffect } from 'react';
import { autorun } from 'mobx';
import { observer } from 'mobx-react-lite';
import { Grid, Divider, Box } from '@material-ui/core';
import { useWindowSize } from 'react-use';
import { Page, EmptyState, ScreenLoader } from 'components';
import { anketsStore, chatStore, userStore } from 'stores';
import { ru } from 'locale';
import { MessageInput, MessageList } from './components';
import useStyles from './ChatScreen.styles';

const bottomNavigationHeight = 56;

const ChatScreen = observer(() => {
  const [message, setMessage] = useState('');
  const { height: windowHeight } = useWindowSize();
  const { fetchState, messages } = chatStore;
  const { userData } = userStore;
  const hasMessages = messages.length !== 0;
  const pageHeight = windowHeight - bottomNavigationHeight;
  const classes = useStyles();
  const uid = userData?.login.toUpperCase();

  useEffect(
    () =>
      autorun(() => {
        chatStore.getMessages(anketsStore.anketId);
      }),
    [],
  );

  const handleChange = ({ target }) => {
    setMessage(target.value);
  };

  const handleSendMessage = () => {
    chatStore.sendMessage({ uid, text: message });
    setMessage('');
  };

  const renderMessages = () => {
    if (!hasMessages) {
      return (
        <Grid
          container
          item
          direction="column"
          justify="center"
          className={classes.emptyStateContainer}
        >
          {fetchState === 'fulfilled' && <EmptyState title={ru.noMessagesYet} />}
        </Grid>
      );
    }

    return (
      <div className={classes.list}>
        <div className={classes.listInner}>
          <Box p={2}>
            {fetchState === 'fulfilled' && <MessageList messages={messages} uid={uid} />}
          </Box>
        </div>
      </div>
    );
  };

  return (
    <Page className={classes.root} style={{ height: pageHeight }}>
      {fetchState === 'pending' && <ScreenLoader />}

      {renderMessages()}

      <div className={classes.box}>
        <Divider />
        <Box py={1} px={2}>
          <MessageInput value={message} onChange={handleChange} onSend={handleSendMessage} />
        </Box>
        <Divider />
      </div>
    </Page>
  );
});

export default ChatScreen;
